import * as React from 'react';
import { inject, observer } from 'mobx-react';
import TransferEntryDialogStore from 'store/transferEntry.dialog.store';
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle
} from '@material-ui/core';
import { RootStore } from 'store/root.store';
import TimeEntryForm from 'components/TimeEntryForm/TimeEntryForm';
import { Features } from '../../api/types/types';
import { FlexDiv } from 'common/flex';
import { ApiConsumer } from 'common/ApiProvider';
import RootAPI from '../../api/interfaces/RootAPI';
import AutoCompleteField from 'components/AutoCompleteField/AutoCompleteField';
import Template from '../../api/immutables/ImmutableTemplate';
import { FeaturesConsumer } from 'common/FeaturesProvider';
import { DateTime } from 'luxon'
import { withTranslation } from 'react-i18next';
import { getTemplateTooltipText } from 'util/template';

interface Props {
    store?: TransferEntryDialogStore;
    // tslint:disable-next-line:no-any
    t: any;
}

@inject((allStores: { rootStore: RootStore }) => {
    let rootStore = allStores.rootStore;
    return {
        store: rootStore.transferEntryDialogStore
    };
})
@observer
class TransferEntryDialog extends React.Component<Props> {

    render() {
        const { t, store } = this.props;
        const {
            isOpen,
            cancel,
            entry,
            selectedTemplate,
            setTemplate,
            changeEntry,
            saving,
            wrappedSaveTransferredEntries,
            wrappedPostTransferredEntries,
            durationValidationState,
            setFieldLoaderFn,
            validationState,
            rootStore
        } = store!;
        const fetchTemplates = rootStore.templateStore.fetchTemplatesInAutoComplate;
        const tkOfficesToShow = rootStore.appStore.getActiveTKOfficesForDate((DateTime.fromISO(entry && entry.workDateTime)));

        return (
            <FeaturesConsumer>
                {(features: Features) =>
                    <>
                        <Dialog
                            PaperProps={{ style: { overflow: 'visible', maxWidth: '1024px' } }}
                            disableBackdropClick={true}
                            disableEscapeKeyDown={true}
                            open={isOpen}
                            onClose={cancel}
                            scroll="paper"
                            maxWidth="md"
                            aria-labelledby="scroll-dialog-title"
                            fullWidth={true}
                        >
                            <DialogTitle
                                id="dialog-transfer-title"
                                style={{ paddingBottom: 0 }}
                            >
                                {t('dialog.transfer.title')}
                            </DialogTitle>
                            <DialogContent>
                                <FlexDiv direction="row" style={{ alignItems: 'flex-end' }}>
                                    <FlexDiv flex={1} />
                                    {entry && !entry.isPosted() && <ApiConsumer>
                                        {(api: RootAPI) =>
                                            <div>
                                                <AutoCompleteField
                                                    label={t('field.template.title')}
                                                    fetch={(search: string) => fetchTemplates(search, entry)}
                                                    currentItem={selectedTemplate}
                                                    clearable={true}
                                                    disabled={false}
                                                    onClear={() => setTemplate(undefined)}
                                                    getItemText={(m: Template) => `${m.name}`}
                                                    onSelect={setTemplate}
                                                    width={200}
                                                    tooltip={(m: Template) => getTemplateTooltipText(m, t)}
                                                />
                                            </div>}

                                    </ApiConsumer>}
                                </FlexDiv>
                                <TimeEntryForm
                                    timeEntry={entry}
                                    durValidationState={durationValidationState}
                                    onChange={changeEntry}
                                    minHeight={80}
                                    validationState={validationState}
                                    actionCodesRequired={features.EpochConfigActionCodesRequired}
                                    minNarrativeLength={features.EpochConfigNarrativesMinimumChars}
                                    maxNarrativeLength={features.EpochConfigNarrativesMaximumChars}
                                    includeDuration={false}
                                    includeNarrative={false}
                                    onSetFieldLoader={setFieldLoaderFn}
                                    tkOfficesToShow={tkOfficesToShow!}
                                />
                            </DialogContent>
                            <DialogActions>
                            {entry && !entry.matterId && entry.reference && <div style={{ paddingLeft: 12 }}>
                                    <span>`${t('field.reference')}: `</span>
                                    <span>{entry.reference}</span>
                                </div>}

                                <FlexDiv flex={1}/>
                                {entry && !entry.isPosted() &&
                                    <>
                                        <Button disabled={saving} onClick={wrappedSaveTransferredEntries}>{t('save', { ns: 'common' })}</Button>
                                        <Button disabled={saving} onClick={wrappedPostTransferredEntries}>{t('action.post')}</Button>
                                    </>
                                }
                                <Button onClick={cancel}>{t('cancel', { ns: 'common' })}</Button>
                            </DialogActions>
                        </Dialog>
                    </>
                }
            </FeaturesConsumer>
        );
    }
}

export default withTranslation(['timeentries', 'common'])(TransferEntryDialog);